import { SortingOption } from '@epam/uui-core';

export const sortBy = <T>(
  item: T,
  sorting: SortingOption<keyof T>,
): string | number => item[sorting.field as keyof T] as string | number;
